module.exports = __webpack_public_path__ + "03_long_black.f3a0663e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_long_black.png
// module id = Eq0h
// module chunks = 0